import { useEffect } from "react";
import "./index.style.css";

// Elfsight Google Reviews
const ELFSIGHT_SCRIPT = "https://elfsightcdn.com/platform.js";
const ELFSIGHT_APP_CLASS = "elfsight-app-2f7f60e0-121a-46ef-8624-4fe90325261f";

const Reviews = () => {
  useEffect(() => {
    // Charge le script Elfsight une seule fois
    if (document.querySelector(`script[src="${ELFSIGHT_SCRIPT}"]`)) return;
    const s = document.createElement("script");
    s.src = ELFSIGHT_SCRIPT;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section id="avis" className="reviews">
      <div className="reviews-inner">
        <h2 className="reviews-title">
          Avis de nos clients
          <span className="reviews-underline" />
        </h2>
        <p className="reviews-sub">Ce que nos clients disent de nous.</p>
        <div className={ELFSIGHT_APP_CLASS} data-elfsight-app-lazy></div>
      </div>
    </section>
  );
};

export default Reviews;
